<template>
  <div class="brand-story">
    <NavComponent :index="1"></NavComponent>
    <div
      class="banner"
      v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/story-banner.jpg)'}"
    ></div>
    <div class="story content-container">
      <div class="list-item">
        <div class="list-left">
          <h4>品牌可信赖</h4>
          <div class="tips">
            入驻英国8大主要城市，服务超过20000名租客，管理超400套房源
          </div>
          <p>
            汉伦拥有10多年的英国本土房地产投资与物业管理经验，全方位无缝对接当地资源，能为投资客户和业主提供综合性、一站式房地产投资与物业管理服务。
          </p>
        </div>
        <div
          class="right-img"
          v-bind:style="{ backgroundImage: 'url(' + story_img4 + ')' }"
        ></div>
      </div>
      <div class="list-item">
        <div
          class="right-img"
          v-bind:style="{ backgroundImage: 'url(' + story_img3 + ')' }"
        ></div>
        <div class="list-left">
          <h4>收益更稳健</h4>
          <div class="tips">报告定期发，收益全知道</div>
          <p>
            汉伦为您量身定制个性化托管方案和营销策略。拥有强大的房屋出租能力，不用担心房屋空置。房屋租金定时支付，收益报告定期发送，让您的投资收益尽在掌控。
          </p>
        </div>
      </div>
      <div class="list-item">
        <div class="list-left">
          <h4>维护有保障</h4>
          <div class="tips">专业人员处理手续，房产维护专人对接</div>
          <p>
            英文账单看不懂？物业信件很头疼？资深工作人员为您处理房产相关的各项费用(物业费、地租费，水电燃气和网络)，确保您和租客毫无后顾之忧。此外，还有专业的维修和清洁团队，为您和租客保驾护航。
          </p>
        </div>
        <div
          class="right-img"
          v-bind:style="{ backgroundImage: 'url(' + story_img1 + ')' }"
        ></div>
      </div>
      <div class="list-item">
        <div
          class="right-img"
          v-bind:style="{ backgroundImage: 'url(' + story_img2 + ')' }"
        ></div>
        <div class="list-left">
          <h4>租客有保证</h4>
          <div class="tips">严格筛选优质租客，律师团队助您摆脱风险</div>
          <p>
            每一位租客都需要经过严格的筛选，专业团队会对租客的征信背景进行调查，帮您规避不必要的经济风险。专业律师团队起草合同，最大限度保障您和租客的共同利益。
          </p>
        </div>
      </div>
      <h4 style="text-align: center">房东故事</h4>
      <div class="landlord-story">
        <ul>
            <li v-for="(item,index) in storyList" :key="index">
                <img :src="item.image" />
                <div class="landlord-name">
                    <span>房东</span>
                    <span class="name">{{item.title}}</span>
                </div>
                <p>{{item.description}}</p>
            </li>
        </ul>
      </div>
      <h4 style="text-align: center">海外房产托管流程</h4>
      <div class="hosting-step">
        <ul>
          <li v-for="(item,index) in setpList" :key="index">
              <div>
                <img class="step-img" :src="item.image" />
                <h4>{{item.name}}</h4>
                <p>{{item.p1}}</p>
                <p>{{item.p2}}</p>
                <p v-if="item.p3">{{item.p3}}</p>
              </div>
          </li>
        </ul>
      </div>
    </div>
    <SideBarComponent></SideBarComponent>
    <FooterComponent></FooterComponent>
  </div>
</template>
<script>
import FooterComponent from "@components/FooterComponent";
import NavComponent from "@components/NavComponent";
import SideBarComponent from "@components/SideBarComponent";
import story_img1 from "@assets/image/story/story-img1.jpg";
import story_img2 from "@assets/image/story/story_img2.jpg";
import story_img3 from "@assets/image/story/story-img3.jpg";
import story_img4 from "@assets/image/story/story_img4.jpg";
import step_image1 from "@assets/image/story/step-image1.jpg";
import step_image2 from "@assets/image/story/step-image2.jpg";
import step_image3 from "@assets/image/story/step-image3.jpg";


export default {
  name: "MoveHousePage",
  computed: {},
  components: {
    FooterComponent,
    NavComponent,
    SideBarComponent,
  },
  data() {
    return {
      story_img1,
      story_img2,
      story_img3,
      story_img4,
      setpList:[
        {image:step_image1,name:'说明委托信息',p1:'请致电010-8418 5298',p2:'或联系页面下方物业管理专用微信',p3:'(详见页面底部栏二维码)'},
        {image:step_image2,name:'定制出租方案',p1:'英国工作人员上门实勘报价',p2:'制定出租委托方案'},
        {image:step_image3,name:'签署物业管理协议',p1:'签署物业管理协议',p2:'尊享汉伦资产管理服务'},
      ],
      storyList:[]
    };
  },
  mounted() {
    this.getBrandStory()
  },
  methods: {
    getBrandStory(){
      var that = this
      this.axios.get(this.url+'/api/web/cms/fangdonggushi',).then(function(response){
        that.storyList = response.data.data
      }).catch(function() {
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 58vh;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}
.story {
  padding: 2rem 0;
  .list-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5rem;
    .list-left {
      width: 24.4rem;
    }
    .right-img {
      width: 20rem;
      height: 10rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    p {
      font-size: 0.9rem;
      line-height: 1.5rem;
      letter-spacing: 0rem;
      color: $font;
    }
    .tips {
      color: $bgcolor;
      font-size: 1rem;
      line-height: 1.6rem;
      letter-spacing: 0rem;
      margin: 0.5rem 0 1.5rem 0;
    }
  }
  h4 {
    font-size: 1.5rem;
    font-weight: bold;
    font-stretch: normal;
    line-height: 3.2rem;
    letter-spacing: 0rem;
    color: $color;
  }
  .landlord-story{
      color: #3a4a5b;
      .landlord-name{
            display:flex;
            justify-content: space-between;
            line-height: 3rem;
            margin-bottom: 1.2rem;
            border-bottom: dashed 0.05rem #6985a8;
            .name{
                color: #0e2d57;
                font-weight: 700;
            }
        }
      ul{
          display: flex;
          justify-content: space-between;
          margin:4rem auto 4rem;
          li{
            width: 18rem;
            padding: 0 1.5rem 2.4rem;
            box-sizing:border-box;
            background: #f3f3f3;
            box-shadow: 0rem -0.2rem 0rem 0rem 
            rgba(58, 74, 91, 0.9);
            border-radius: 0.3rem;
            p{
                font-size: 0.8rem;
                line-height: 1.6rem;
            }
            img{
                width: 5rem;
                height: 5rem;
                border-radius: 50%;
                display:block;
                margin: -2.5rem auto 0;
            }
          }
      }
  }
  .hosting-step{
      ul{
          display: flex;
          justify-content: space-between;
          margin:2rem auto 5rem;
          li{
              width: auto;
              height: auto;
              text-align: center;
              display: flex;
              align-items: center;
              h4{
                  font-size: 1.2rem;
              }
              p{
                  color: #3a4a5b;
                  font-size: 0.9rem;
                  line-height: 1.4rem;
              }
              .step-img{
                  margin-left: 3rem;
                  width: 7.1rem;
                  height: 7.8rem;
              }
          }
          li:not(:last-child)::after{
            content: '';
            width: 10rem;
            display: inline-block;
            border-bottom: dashed 0.2rem #e5e5e5;
            margin-left: 1rem;
          }
      }
  }
}
</style>